import { useFormContext } from 'react-hook-form';
import { createOption } from '@mews-commander/ui';
import { Option } from '@mews-commander/types';
import { lt } from '@mews/framework';
import { CancellationPolicyApplicability } from '@mews-commander/data-access';
import { SelectField } from '@mews-commander/form';
import { CancellationPolicyFormField, CancellationPolicyOffsetType } from '../../types';
import { FormValues } from '../schema';

export const ApplicabilitySelectField = () => {
    const { setValue } = useFormContext<FormValues>();
    return (
        <SelectField
            name={CancellationPolicyFormField.Applicability}
            required
            options={applicabilityOptions}
            showEmptyValue={false}
            onChange={(_, value) => {
                if (value === CancellationPolicyApplicability.Creation) {
                    setValue(CancellationPolicyFormField.OffsetType, CancellationPolicyOffsetType.After);
                }
            }}
        />
    );
};

const applicabilityOptions: Option[] = [
    createOption({
        label: lt('CancellationPolicyApplicabilityConfirmation'),
        value: CancellationPolicyApplicability.Creation,
    }),
    createOption({
        label: lt('CancellationPolicyApplicabilityArrivalDate'),
        value: CancellationPolicyApplicability.StartDate,
    }),
    createOption({
        label: lt('CancellationPolicyApplicabilityCheckInTime'),
        value: CancellationPolicyApplicability.Start,
    }),
];
